import React from 'react';
import { FormControl, FormErrorMessage, FormLabel, Input } from '@chakra-ui/react';
import InputMask from 'react-input-mask';
import { Controller } from 'react-hook-form';
import { FieldGroup, fieldPadding } from '../FieldGroup';
import { iconForFieldName, iconForMask } from '../fieldIcons';

interface InputInterface {
  name: string | undefined | any;
  label: string | undefined;
  placeholder?: string | undefined;
  iconLeft?: JSX.Element | null;
  iconRight?: JSX.Element;
  mask: string;
  isRequired?: boolean;
  isDisabled?: boolean;
  isLoading?: boolean;
  control: any;
  errors: any;
}

export const MaskedInputForm = ({
  name,
  label,
  placeholder,
  iconLeft,
  iconRight,
  mask,
  isRequired,
  isDisabled,
  isLoading = false,
  control,
  errors,
  ...props
}: InputInterface) => {
  const resolvedIconLeft =
    iconLeft === null ? undefined : iconLeft ?? iconForMask(mask) ?? iconForFieldName(name);
  const hasRight = Boolean(iconRight) || isLoading;

  return (
    <FormControl isRequired={isRequired} isDisabled={isDisabled} isInvalid={!!errors[name]}>
      <FormLabel htmlFor={name}>{label}</FormLabel>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <FieldGroup iconLeft={resolvedIconLeft} iconRight={iconRight} isLoading={isLoading}>
            <Input
              id={name}
              placeholder={placeholder}
              mask={mask}
              maskChar=""
              as={InputMask}
              {...fieldPadding(Boolean(resolvedIconLeft), hasRight)}
              {...field}
              {...props}
            />
          </FieldGroup>
        )}
      />
      {errors[name] && <FormErrorMessage>{errors[name]?.message}</FormErrorMessage>}
    </FormControl>
  );
};
